import { render, staticRenderFns } from "./FacialDeviceEmployeeTable.vue?vue&type=template&id=48aafef0&scoped=true&"
import script from "./FacialDeviceEmployeeTable.vue?vue&type=script&lang=js&"
export * from "./FacialDeviceEmployeeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aafef0",
  null
  
)

export default component.exports